import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Briefcase, Building2, Users } from "lucide-react";
import Companies from "./Companies";
import Contacts from "./Contacts";

export default function Clients() {
  const [activeTab, setActiveTab] = useState("empresas");

  return (
    <div className="space-y-6 animate-in fade-in-50 duration-300">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-2xl font-bold text-slate-900">
            Gestión Integral de Clientes
          </h1>
          <p className="text-slate-600">
            Centraliza la información de tus empresas y sus contactos
          </p>
        </div>
      </div>

      <div className="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden">
        <Tabs
          value={activeTab}
          onValueChange={setActiveTab}
          className="w-full"
        >
          <div className="px-6 border-b border-slate-100 bg-slate-50/50">
            <TabsList className="bg-transparent h-14 p-0 space-x-8">
              <TabsTrigger
                value="empresas"
                className="data-[state=active]:border-b-2 data-[state=active]:border-slate-900 data-[state=active]:text-slate-900 rounded-none h-full bg-transparent px-2 font-medium text-slate-500 hover:text-slate-700 transition-colors"
              >
                <div className="flex items-center gap-2">
                  <Building2 className="h-4 w-4" />
                  Empresas Corporativas
                </div>
              </TabsTrigger>
              <TabsTrigger
                value="contactos"
                className="data-[state=active]:border-b-2 data-[state=active]:border-slate-900 data-[state=active]:text-slate-900 rounded-none h-full bg-transparent px-2 font-medium text-slate-500 hover:text-slate-700 transition-colors"
              >
                <div className="flex items-center gap-2">
                  <Users className="h-4 w-4" />
                  Directorio de Contactos
                </div>
              </TabsTrigger>
            </TabsList>
          </div>

          <div className="p-6">
            <TabsContent value="empresas" className="mt-0 outline-none">
              <Companies hideHeader={true} />
            </TabsContent>

            <TabsContent value="contactos" className="mt-0 outline-none">
              <Contacts hideHeader={true} />
            </TabsContent>
          </div>
        </Tabs>
      </div>
    </div>
  );
}
